// src/api/vehicleAvailabilityApi.js
import api from "./axios";

export async function fetchAvailabilityBlocks(regNo, fromDate, toDate) {
  const { data } = await api.get(
    `/api/vehicles/${encodeURIComponent(regNo)}/availability-blocks`,
    { params: { from: fromDate, to: toDate } }
  );
  return data;
}

export async function createAvailabilityBlock(regNo, payload) {
  const { data } = await api.post(
    `/api/vehicles/${encodeURIComponent(regNo)}/availability-blocks`,
    payload
  );
  return data;
}

export async function deleteAvailabilityBlock(blockId) {
  await api.delete(`/api/vehicles/availability-blocks/${blockId}`);
}
